var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGrediant(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1963,
    height: 1710,
    viewBox: "0 0 1963 1710",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.15,
    filter: "url(#filter0_f_2514_42955)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1319.79 960.827C1164.61 960.827 1038.82 826.754 1038.82 661.367C1038.82 495.979 1164.61 361.906 1319.79 361.906C1474.97 361.906 1600.77 495.979 1600.77 661.367C1600.77 826.754 1474.97 960.827 1319.79 960.827Z",
    fill: "#FF6D4C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1006.58 1266.25C851.397 1266.25 725.599 1132.18 725.599 966.794C725.599 801.407 851.397 667.334 1006.58 667.334C1161.76 667.334 1287.56 801.407 1287.56 966.794C1287.56 1132.18 1161.76 1266.25 1006.58 1266.25Z",
    fill: "#FEBE58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1320.01 1348.41C1164.83 1348.41 1039.04 1214.33 1039.04 1048.95C1039.04 883.558 1164.83 749.485 1320.01 749.485C1475.19 749.485 1600.99 883.558 1600.99 1048.95C1600.99 1214.33 1475.19 1348.41 1320.01 1348.41Z",
    fill: "#DE2BAE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M642.978 1121.48C487.798 1121.48 362 987.411 362 822.023C362 656.636 487.798 522.563 642.978 522.563C798.157 522.563 923.956 656.636 923.956 822.023C923.956 987.411 798.157 1121.48 642.978 1121.48Z",
    fill: "#24EDFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1104.08 1219.47C948.899 1219.47 823.1 1085.39 823.1 920.008C823.1 754.62 948.899 620.547 1104.08 620.547C1259.26 620.547 1385.06 754.62 1385.06 920.008C1385.06 1085.39 1259.26 1219.47 1104.08 1219.47Z",
    fill: "#ADFF99"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_2514_42955",
    x: 0.904755,
    y: 0.811249,
    width: 1961.18,
    height: 1708.69,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 180.548,
    result: "effect1_foregroundBlur_2514_42955"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrediant);
export default __webpack_public_path__ + "static/media/grediant.59e6895242a46d69bb7bc25cb5b4d8e7.svg";
export { ForwardRef as ReactComponent };